import React, { useState } from 'react'
import { useForm, Controller } from "react-hook-form";
import {
  TextField,
  Stack,
  Autocomplete,
  Chip,
  FormHelperText,
} from "@mui/material";
import { useClient } from "../../../reactQuery/client";
import Checked from "../../../styles/svg/checked.svg";
import Unchecked from "../../../styles/svg/uncheck.svg";
import addClient from '../../../styles/svg/AddClient.svg'

const ClientSelection = ({ control, errors, recipients, setRecipients }) => {
  const { responseData, isLoading } = useClient({
    pagination: false,
    status: `&status=Active`,
  });

  const options = [
    { label: "Select All", value: "select_all" },
    ...(responseData?.map((item) => ({
      label: item.company_name,
      value: item.client_id,
      mail: item.user.email,
      manager: item.user.name,
    })) || []),
  ];



  const handleSelectAll = (isAllSelected) => {
    if (!isAllSelected) {
      setRecipients(
        options
          .filter((option) => option.label !== "Select All")
          .map((option) => option.value)
      ); // Select all
    } else {
      setRecipients([]); // Deselect all
    }
  };

  return (
    <div className="client-messaging">
      <Controller
        name="client_ids"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <Autocomplete
            {...field}
            multiple
            limitTags={3}
            options={options || []}
            value={recipients}
            onChange={(event, newValue) => {
              setRecipients(newValue);
              field.onChange(newValue); // Save selected recipients in react-hook-form
            }}
            loading={isLoading}
            //   error={!!field?.state?.error}
            error={!!errors.client_ids}
            helperText={errors.client_ids ? errors.client_ids?.message : ""}
            popupIcon={<img src={addClient} alt='add-client' />}
            filterOptions={(options, { inputValue }) => {
              const lowercasedInput = inputValue.toLowerCase();
              return options.filter((option) => {
                const labelMatch = option.label
                  ?.toLowerCase()
                  ?.includes(lowercasedInput);
                const mailMatch = option.mail
                  ?.toLowerCase()
                  ?.includes(lowercasedInput);
                const managerMatch = option.manager
                  ?.toLowerCase()
                  ?.includes(lowercasedInput);
                return labelMatch || mailMatch || managerMatch; // Match either label or email
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Recipients"
                variant="outlined"
                fullWidth
                error={!!field?.state?.error}
                helperText={
                  field?.state?.error ? field?.state?.error?.message : ""
                }
              />
            )}
            renderOption={(props, option) => (
              <>
                <li
                  {...props}
                  className={`MuiAutocomplete-option client-selection-option ${
                    props["data-option-index"] % 2 !== 0 ? "odd-row" : ""
                  }`}
                  onClick={() => {
                    if (option.label === "Select All") {
                      handleSelectAll(recipients.length === options.length - 1);
                    } else {
                      const newRecipients = recipients.includes(option.value)
                        ? recipients.filter(
                            (recipient) => recipient !== option.value
                          )
                        : [...recipients, option.value];
                      setRecipients(newRecipients);
                      field.onChange(newRecipients); // Save selected recipients in react-hook-form
                    }
                  }}
                >
                  <img
                    className="mr-2"
                    src={
                      recipients.includes(option.value) ||
                      (recipients.length === options.length - 1 &&
                        option.label === "Select All")
                        ? Checked
                        : Unchecked
                    }
                    alt="checked"
                  />
                  <span className="checkmark-large"></span>
                  <span className="client-selection-option-label">
                    {option.label}
                  </span>
                  <span className="client-selection-option-label">
                    {option.manager}
                  </span>
                  <span className="client-selection-option-email">
                    {option.mail}
                  </span>
                </li>
              </>
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  label={
                    options.find((o) => o.value === option)?.label || option
                  }
                  onDelete={() => {
                    const newRecipients = recipients.filter(
                      (recipient) => recipient !== option
                    );
                    setRecipients(newRecipients);
                    field.onChange(newRecipients); // Update react-hook-form with new recipients
                  }}
                />
              ))
            }
          />
        )}
      />
      <FormHelperText error={!!errors.client_ids} sx={{ marginLeft: "14px" }}>
        {errors.client_ids ? errors.client_ids?.message : ""}
      </FormHelperText>
    </div>
  );
};

export default ClientSelection